module.exports = {
    getPlural: (n, s1, s2, s3) => {
        n = Math.floor(n);
        return n % 10 == 1 && n % 100 !== 11 ? s1 : (n % 10 > 1 && n % 10 < 5 && (n % 100 < 10 || n % 100 > 19) ? s2 : s3);
    },
    getPluralEn: (n, s1, s2) => {
        return n < 2 && n > 0 ? s1 : s2;
    }
};